import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import Icon from '../../../Icons'
import DetailsItem from '../components/DetailsItem/DetailsItem'
import {
  renderEvidence,
  mapActivityBasicInformation,
  mapClientActivityDetails,
  mapActivityCanceledDetails,
  mapRewardBasicInformation,
  mapRewardDetails,
  mapRewardDeclinedDetails,
} from '../helpers'

const RewardsClientActivityDetailsModal = ({ onClose = () => {}, activity, building }) => {
  const { t } = useTranslation(['rewards-loyalty'])
  const { timezone } = building
  const { displayType, status } = activity
  const isReward = ['reward-redeemed', 'reward-declined'].includes(displayType)
  const [photoIndexToDisplay, setPhotoIndexToDisplay] = useState(null)

  const onOpenImageModal = (index) => setPhotoIndexToDisplay(index)

  const items = useMemo(() => {
    const result = !isReward
      ? [
          {
            data: mapActivityBasicInformation(activity, timezone, t),
            title: t('rewards-loyalty:clientActivityDetails.basicInformation'),
          },
          {
            data: mapClientActivityDetails(activity, t),
            title: t('rewards-loyalty:clientActivityDetails.activityDetails'),
          },
        ]
      : [
          {
            data: mapRewardBasicInformation(activity, timezone, t),
            title: t('rewards-loyalty:clientActivityDetails.basicInformation'),
          },
          {
            data: mapRewardDetails(activity, t),
            title: t('rewards-loyalty:clientActivityDetails.rewardDetail'),
          },
        ]

    switch (displayType) {
      case 'points-cancelled':
        result.push({
          data: mapActivityCanceledDetails(activity, timezone, t),
          title: t('rewards-loyalty:clientActivityDetails.cancelationDetails'),
        })
        break
      case 'reward-declined':
        result.push({
          data: mapRewardDeclinedDetails(activity, timezone, t),
          title: t('rewards-loyalty:clientActivityDetails.declineDetails'),
        })
        break
      default:
        break
    }

    return result
  }, [displayType])

  const modalTitle = () => {
    if (isReward) {
      return displayType === 'reward-declined'
        ? t('rewards-loyalty:clientActivityDetails.redemptionDeclinedDetailsTitle')
        : t('rewards-loyalty:clientActivityDetails.redemptionDetailsTitle')
    }

    if (status === 'declined' || displayType === 'points-declined') {
      return t('rewards-loyalty:clientActivityDetails.notApprovedDetailsTitle')
    }

    return displayType === 'points-cancelled'
      ? t('rewards-loyalty:clientActivityDetails.pointsCanceledDetailsTitle')
      : t('rewards-loyalty:clientActivityDetails.pointsEarnedDetailsTitle')
  }

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={modalTitle()}
      headerIcon={
        !isReward ? <Icon icon="charityCoins" /> : <Icon icon="gift" viewBox="0 0 25 25" />
      }
    >
      <div
        className="rewards-modal-content rewards-base-view activity-evidence"
        style={{ paddingBottom: 20 }}
      >
        {items.map((item, index) => (
          <DetailsItem data={item.data} title={item.title} key={index} />
        ))}
        {!isReward && (
          <div className="rewards-modal-input-row">
            <div className="input-container">
              <div className="input-label">
                {t('rewards-loyalty:evidence.activityCompletionEvidence')}
              </div>
              {renderEvidence(activity, onOpenImageModal, photoIndexToDisplay, t)}
            </div>
          </div>
        )}
      </div>
    </ModalContainer>
  )
}

RewardsClientActivityDetailsModal.propTypes = {
  onClose: PropTypes.func,
  activity: PropTypes.object,
  building: PropTypes.object,
}

export default RewardsClientActivityDetailsModal
